import { Box, Button, Modal, Typography } from '@mui/material'
import CustomText from 'components/common/CustomText/CustomText';
import React from 'react'

interface Props {
  open: boolean;
  title: string;
  message: string;
  content?: React.ReactNode,
  buttons: any[];
}

function CustomDialog({ open, title, message, buttons, content }: Props) {
  return (
    <Modal open={open}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
          minWidth: 300,
        }}
      >
        <Box my={0.2}>
          <CustomText text={title} fontWeight={700} fontSize={20} />
        </Box>

        <Box mt={1}>
          <CustomText text={message} fontSize={18} />
        </Box>

        {content && <Box>
          {content}
        </Box>}

        <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
          {buttons.map((item) => (
            item
          ))}
        </Box>
      </Box>
    </Modal>
  )
}

export default CustomDialog
